import { render, staticRenderFns } from "./MadeWithLove.vue?vue&type=template&id=2a4e0b90&scoped=true&"
import script from "./MadeWithLove.vue?vue&type=script&lang=js&"
export * from "./MadeWithLove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e0b90",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/elements/MadeWithLove.vue
// module id = null
// module chunks = 